import { createFileRoute } from "@tanstack/react-router";
import { PointFlowCanvas } from "@/app/components/pointflow/PointFlowCanvas";
import { useDataSync } from "@/app/hooks/useDataSync";

export const Route = createFileRoute("/orgchart")({
  component: OrgChartPage,
});

function OrgChartPage() {
  // Ensure data is loaded when accessing pointflow page directly
  useDataSync();

  return (
    <div className="h-[calc(100vh-84px)] w-full bg-stone-50">
      {/* Main flow canvas */}
      <div className="w-full h-full relative">
        <PointFlowCanvas />

        {/* Header overlay */}
        <div className="absolute top-4 left-4 z-40 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-sm border border-stone-200">
          <h1 className="text-lg font-semibold text-stone-900">Org Chart</h1>
        </div>
      </div>
    </div>
  );
}
